<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 18:24:07
 * @Description: 消防检测项目新增
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        检测项目新增
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        />

        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->
    <!-- 内容页标题 -->

    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          :inline="true"
          label-suffix="："
          :model="fd"
          :rules="fdRules"
          label-position="right"
          label-width="160px"
          class="c-form"
        >
          <!-- 基本信息 -->
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              基础信息
            </el-col>

            <!-- <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="重点单位"
                prop="zddw"
              >
                <el-radio-group
                  v-model="fd.zddw"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    是
                  </el-radio>
                  <el-radio label="N">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="签到要求"
                prop="qdyq"
              >
                <el-radio-group
                  v-model="fd.qdyq"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="item in qdlxType"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model="fd.xmmc"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="所属区域"
                prop="areaDm"
              >
                <select-address
                  v-model="fd.areaDm"
                  required
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目地址"
                prop="xmdz"
              >
                <el-input
                  v-model="fd.xmdz"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入项目地址"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目概况"
                prop="xmgs"
              >
                <el-input
                  v-model="fd.xmgs"
                  class="c-form__input"
                  type="textarea"
                  rows="4"
                  placeholder="请输入项目概况"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="联系人"
                prop="lxr"
              >
                <el-input
                  v-model="fd.lxr"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入联系人"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="lxdh"
              >
                <el-input
                  v-model="fd.lxdh"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入联系电话"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
                prop="wtdw"
              >
                <el-input
                  v-model="fd.wtdw"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入委托单位"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="统一社会信用代码"
                prop="shxydm"
              >
                <el-input
                  v-model="fd.shxydm"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入统一社会信用代码"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="设计单位"
                prop="sjdw"
              >
                <el-input
                  v-model="fd.sjdw"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入设计单位"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="施工单位(维保单位)"
                prop="sgdw"
              >
                <el-input
                  v-model="fd.sgdw"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入施工单位"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              合同信息
            </el-col> -->
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="合同名称"
                prop="htmc"
              >
                <el-input
                  v-model="fd.htmc"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入合同名称"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="合同金额（元）"
                prop="htje"
              >
                <el-input
                  v-model="fd.htje"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入合同金额"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="合同扫描件"
                prop="htFileId"
              >
                <file-serve-upload
                  ref="htsmjFileUpload"
                  v-model="fd.htFileId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                  <span class="u-text-warning">（只能上传一份 doc / docx / pdf 文件，且不超过10M）</span>
                </file-serve-upload>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测方案"
                prop="jcfaFileId"
              >
                <file-serve-upload
                  ref="jcfaFileUpload"
                  v-model="fd.jcfaFileId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                  <span class="u-text-warning">（只能上传一份 doc / docx / pdf 文件，且不超过10M）</span>
                </file-serve-upload>
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测内容"
                prop="jcnrList"
              >
                <el-checkbox-group
                  v-model="fd.jcnrList"
                  class="c-form__checkbox-group"
                >
                  <el-checkbox
                    v-for="item in jcnrXtList"
                    :key="item.jcnrId"
                    class="dev-pDetail"
                    :label="item.jcnrId"
                  >
                    {{ item.jcnrMc }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测依据"
                prop="jcyj"
              >
                <!-- <span style="font-size: 8px; color: #e6a23c;">
                  ** 录入多份检测依据用；隔开 **
                </span> -->
                <el-input
                  v-model="fd.jcyj"
                  class="c-form__input"
                  type="textarea"
                  rows="3"
                  placeholder="请输入检测依据"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="13"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测日期"
                prop="jcrqQZ"
              >
                <hm-date-range
                  ref="dateRange"
                  v-model="fd.jcrqQZ"
                  range-separator="至"
                  start-placeholder="检查日期"
                  end-placeholder="完成日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col c-form__placeholder"
              :span="11"
            />
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="消防批文"
                prop="xfpw"
              >
                <span style="font-size: 8px; color: #e6a23c;">
                  ** 录入多个消防批文字号用；隔开 **
                </span>
                <el-input
                  v-model.trim="fd.xfpw"
                  class="c-form__input"
                  type="textarea"
                  rows="3"
                  placeholder="请输入消防批文字号"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目负责人"
                prop="xmfzrDm"
              >
                <select-xm-user
                  v-model="fd.xmfzrDm"
                  placeholder="请选择项目负责人"
                  role-code="FireEngineer"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="审核人"
                prop="shrDm"
              >
                <select-xm-user
                  v-model="fd.shrDm"
                  placeholder="请选择项目审核人"
                  role-code="JCXMSHR"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="现场检测员"
                prop="xcjcyDm"
              >
                <select-xm-user
                  v-model="fd.xcjcyDm"
                  placeholder="请选择现场检测员"
                  role-code="JCRY"
                  multiple
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="批准人（签章）"
                prop="spr"
              >
                <select-xm-user
                  v-model="fd.spr"
                  placeholder="请选择项目批准人"
                  role-code="FireEngineer"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              检测建筑物概况
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="竣工日期"
                prop="jgrq"
              >
                <el-date-picker
                  v-model="fd.jgrq"
                  value-format="timestamp"
                  placeholder="选择竣工日期"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="竣工图纸提供情况"
                prop="jgtztgqk"
              >
                <el-input
                  v-model="fd.jgtztgqk"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入竣工图纸提供情况"
                />
                <!-- <el-radio-group
                  v-model="fd.jgtztgqk"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    已提供
                  </el-radio>
                  <el-radio label="N">
                    未提供
                  </el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="建筑总面积（m²）"
                prop="jzmj"
              >
                <el-input
                  v-model="fd.jzmj"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入建筑总面积"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测面积（m²）"
                prop="jcmj"
              >
                <el-input
                  v-model="fd.jcmj"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入检测面积"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="建筑类别"
                prop="jzlbDm"
              >
                <el-select
                  v-model="fd.jzlbDm"
                  class="c-form__select"
                  placeholder="请选择建筑类别"
                  clearable
                >
                  <el-option
                    v-for="item in jzlbType"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="建筑楼层/建筑高度（m）"
                prop="jzlc"
              >
                <el-input
                  v-model="fd.jzlc"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入建筑楼层"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="建筑高度（m）"
                prop="jzgd"
              >
                <el-input
                  v-model="fd.jzgd"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入建筑高度"
                />
              </el-form-item>
            </el-col> -->
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测类型"
                prop="jclx"
              >
                <el-radio-group
                  v-model="fd.jclx"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="item in jzlxType"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测范围"
                prop="jcfw"
              >
                <el-radio-group
                  v-model="fd.jcfw"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="item in jcfwType"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="检测部位"
                prop="jcbw"
              >
                <el-input
                  v-model="fd.jcbw"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入检测部位"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="使用功能"
                prop="sygn"
              >
                <el-input
                  v-model="fd.sygn"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入使用功能"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { xmglService } from './xmgl.service';
import config from '@/config.js';
export default {
  name: 'AddJcxm',
  data () {
    // 手机号码/固定电话检验
    const phoneValid = (rule, value, callback) => {
      const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/;
      if (reg.test(value)) {
        callback();
      }
      callback(new Error('请检查手机号码格式是否正确'));
    };
    return {
      loading: false, // 页面loading状态
      jcnrXtList: null,
      /* 申请信息 Start */
      fd: {
        id: null,
        xmmc: null,
        zddw: null,
        qdyq: '0',
        areaDm: null,
        xmdz: null,
        lxr: null,
        lxdh: null,
        wtdw: null,
        shxydm: null,
        sjdw: null,
        sgdw: null,
        htmc: null,
        htje: null,
        htFileId: null,
        xmgs: null,
        xfpw: null,
        jcyj: '《建筑防火及消防设施检测技术规程》DBJ/T 15-110-2015',
        jcnrList: [],
        jcfaFileId: null,
        jcrqq: null,
        jcrqz: null,
        jcrqQZ: [null, null],
        xmfzrDm: null,
        shrDm: null,
        xcjcyDm: [],
        spr: null,
        jgrq: null,
        jgtztgqk: null,
        jzmj: null,
        jcmj: null,
        jzlbDm: null,
        jzlc: null,
        jzgd: null,
        jclx: null,
        jcfw: null,
        jcbw: null,
        sygn: null
      },
      /* 申请信息 End */

      /** 表单验证规则 Start */
      fdRules: {

        xmmc: [
          this.$validUtils.required('项目名称'),
          this.$HMValidator.maxLength('项目名称', 300)
        ],
        // zddw: [
        //   this.$validUtils.required('重点单位')
        // ],
        // qdyq: [
        //   this.$validUtils.required('签到要求')
        // ],
        areaDm: [
          this.$validUtils.required('所属区域')
        ],
        xmdz: [
          this.$validUtils.required('项目地址'),
          this.$HMValidator.maxLength('项目地址', 300)
        ],
        lxr: [
          this.$validUtils.required('联系人'),
          this.$HMValidator.maxLength('联系人', 50)
        ],
        lxdh: [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.number('联系电话'),
          { validator: phoneValid, trigger: 'change' }
        ],
        wtdw: [
          this.$validUtils.required('委托单位'),
          this.$HMValidator.maxLength('委托单位', 300)
        ],
        shxydm: [
          this.$validUtils.required('统一社会信用代码'),
          this.$HMValidator.tyshxydm('统一社会信用代码')
        ],
        sjdw: [
          this.$validUtils.required('设计单位'),
          this.$HMValidator.maxLength('设计单位', 300)
        ],
        sgdw: [
          this.$validUtils.required('施工单位(维保单位)'),
          this.$HMValidator.maxLength('施工单位(维保单位)', 300)
        ],
        htmc: [
          this.$validUtils.required('合同名称'),
          this.$HMValidator.maxLength('合同名称', 300)
        ],
        htje: [
          this.$validUtils.required('合同金额'),
          this.$HMValidator.money('合同金额', 10, 2)
        ],
        htFileId: [
          this.$validUtils.required('合同扫描件')
        ],
        jcyj: [
          this.$validUtils.required('检测依据'),
          this.$HMValidator.maxLength('检测依据', 3000)
        ],
        jcnrList: [
          this.$validUtils.arrayRequire('检测内容')
        ],
        jcfaFileId: [
          this.$validUtils.required('检测方案')
        ],
        jcrqQZ: [
          this.$HMValidator.dateRangeAllMust('检测日期'),
          this.$HMValidator.dateRange('检查日期')
        ],
        xmfzrDm: [
          this.$validUtils.required('项目负责人')
        ],
        shrDm: [
          this.$validUtils.required('审核人')
        ],
        xcjcyDm: [
          this.$validUtils.required('现场检测员')
        ],
        spr: [
          this.$validUtils.required('批准人（签章）')
        ],
        jgrq: [
          this.$validUtils.required('竣工日期')
        ],
        jgtztgqk: [
          this.$validUtils.required('竣工图纸提供情况'),
          this.$HMValidator.maxLength('竣工图纸提供情况', 100)
        ],
        jzmj: [
          this.$validUtils.required('建筑总面积'),
          this.$HMValidator.money('建筑总面积', 8, 2)
        ],
        jcmj: [
          this.$validUtils.required('检测面积'),
          this.$HMValidator.money('检测面积', 8, 2)
        ],
        jzlbDm: [
          this.$validUtils.required('建筑类别')
        ],
        jzlc: [
          this.$validUtils.required('建筑楼层/建筑高度'),
          this.$HMValidator.maxLength('建筑楼层/建筑高度', 100)
        ],
        // jzgd: [
        //   this.$validUtils.required('建筑高度'),
        //   this.$validUtils.positiveNumber('建筑高度'),
        //   this.$HMValidator.money('建筑高度', 8, 2)
        // ],
        jclx: [
          this.$validUtils.required('检测类型')
        ],
        jcfw: [
          this.$validUtils.required('检测范围')
        ],
        jcbw: [
          this.$validUtils.required('检测部位'),
          this.$HMValidator.maxLength('检测部位', 500)
        ],
        sygn: [
          this.$validUtils.required('使用功能'),
          this.$HMValidator.maxLength('使用功能', 45)
        ],
        xfpw: [this.$HMValidator.maxLength('消防批文', 3000)],
        xmgs: [this.$HMValidator.maxLength('项目概况', 3000)]

      },
      /** 表单验证规则 End */

      /* 文件服务器对接参数 Start */
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'htwj',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */
    };
  },
  computed: {
    /** 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_JC) {
        return enums.IFF_JZLB_JC;
      }
      return {};
    },
    /** 检测类型 */
    jzlxType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JCLX) {
        return enums.IFF_JCLX;
      }
      return {};
    },
    /** 签到类型 */
    qdlxType () {
      // const enums = this.$store.state.apiEnums.iffApi;
      // if (enums && enums.IFF_QDLX) {
      //   return enums.IFF_QDLX;
      // }
      // return {};
      return [{
        id: '0',
        text: 'GPS签到'
      }];
    },
    /** 检测内容类型 */
    // jcnrType () {
    //   const enums = this.$store.state.apiEnums.iffApi;
    //   if (enums && enums.IFF_JCNRLX) {
    //     return enums.IFF_JCNRLX;
    //   }
    //   return {};
    // },
    /** 检测范围类型 */
    jcfwType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JCFWLX) {
        return enums.IFF_JCFWLX;
      }
      return {};
    }

  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
    },
    /**
     * 获取检测项状态
     */
    getXtJcnrList () {
      xmglService.getXtJcnrList()
        .then(rsp => {
          this.jcnrXtList = rsp.data;
        })
        .catch(err => {
          console.error('获取系统检测内容信息失败！', err);
        });
    },
    /**
     * @description: 表单数据封装处理
     * @return {*}
     */
    handleFormData () {
      const _this = this;
      // _this.fd.xcjcy = _this.fd.xcjcy.join(',');
      // _this.fd.jcnrList = _this.fd.jcnrList.join(',');
      [_this.fd.jcrqq, _this.fd.jcrqz] = this.fd.jcrqQZ;
    },
    /**
     * @description: 消防客户信息保存
     * @return {*}
     * @param {*} p
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          _this.handleFormData();

          xmglService.save(_this.fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.fd.id = rsp.data.id;
              _this.closeNavTabAndTo({
                name: 'xmglIndex',
                params: { isRefresh: true }
              }, true);
            })
            .catch(err => {
              console.error('消防客户新增出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }

  },
  created () {
    // this.init();
    this.getXtJcnrList();
  }

};
</script>
